// src/store/modules/organizations.js
import axios from '@/plugins/axios';

const state = {
    userId: null,
    organizations: [], // 每个组织包含 sections 数组，每个分栏包含 sites 数组
};

const getters = {
    allOrganizations: (state) =>
        [...state.organizations].sort((a, b) => a.sortRank - b.sortRank),
};

const actions = {
    /**
     * 获取所有组织数据
     */
    async fetchOrganizations({ commit }) {
        try {
            const response = await axios.get('/admin/getAllSites');
            console.log('API Response (fetchOrganizations):', response);

            // 根据实际 API 返回的数据结构调整访问路径
            if (response && response.code === 200 && Array.isArray(response.data.organizations)) {
                // 确保每个组织都有 sections 字段
                const organizations = response.data.organizations.map(org => ({
                    ...org,
                    sections: Array.isArray(org.sections) ? org.sections : [], // 如果 sections 不存在或不是数组，则赋值为空数组
                }));
                commit('setOrganizations', organizations);
            } else {
                console.error('API 返回的数据结构不正确:', response);
            }
        } catch (error) {
            console.error('获取组织数据失败:', error);
            throw error;
        }
    },

    /**
     * 添加组织
     */
    async addOrganization({ commit }, orgData) {
        try {
            const response = await axios.post('/admin/organization/addOrganizations', orgData);
            if (response.code === 200 && response.data) {
                console.log(response)
                commit('addOrganization', response.data);
            } else {
                console.error('添加组织失败:', response.msg);
                throw new Error(response.msg || '添加组织失败');
            }
        } catch (error) {
            console.error('添加组织失败:', error);
            throw error; // 重新抛出错误以便在组件中捕捉
        }
    },

    /**
     * 更新组织
     */
    async updateOrganization({ commit }, orgData) {
        try {
            const response = await axios.put(`/admin/organization/updateOrganization/${orgData.orgId}`, orgData);

            if (response.code === 200 && response.data) {
                commit('updateOrganization', response.data);
            } else {
                console.error('更新组织失败:', response.msg);
                throw new Error(response.msg || '更新组织失败');
            }
        } catch (error) {
            console.error('更新组织失败:', error);
            throw error;
        }
    },

    /**
     * 删除组织
     */
    async deleteOrganization({ commit }, orgId) {
        try {
            const response = await axios.delete(`/admin/organization/deleteOrganization/${orgId}`);
            if (response.code === 200) {
                commit('deleteOrganization', orgId);
            } else {
                console.error('删除组织失败:', response.msg);
                throw new Error(response.msg || '删除组织失败');
            }
        } catch (error) {
            console.error('删除组织失败:', error);
            throw error;
        }
    },

    /**
     * 重排组织顺序
     */
    async reorderOrganizations({ commit }, organizations) {
        try {
            const response = await axios.post('/admin/organization/reorderOrganizations', { organizations });
            console.log(organizations)
            if (response.code === 200) {
                commit('setOrganizations', organizations);
            } else {
                console.error('重排组织失败:', response.msg);
                throw new Error(response.msg || '重排组织失败');
            }
        } catch (error) {
            console.error('重排组织失败:', error);
            throw error;
        }
    },

};

const mutations = {
    setUserId(state, userId) {
        state.userId = userId;
    },

    // setOrganizations(state, organizations) {
    //     state.organizations = organizations;
    // },

    /**
     * 添加组织
     */
    addOrganization(state, org) {
        state.organizations.push(org);
    },

    /**
     * 更新组织
     */
    updateOrganization(state, updatedOrg) {
        const index = state.organizations.findIndex((org) => org.orgId === updatedOrg.orgId);
        if (index !== -1) {
            state.organizations.splice(index, 1, updatedOrg);
        } else {
            console.error('找不到对应的组织，无法更新');
        }
    },

    /**
     * 删除组织
     */
    deleteOrganization(state, orgId) {
        state.organizations = state.organizations.filter((org) => org.orgId !== orgId);
    },

    /**
     * 重排组织顺序
     */
    setOrganizations(state, organizations) {
        state.organizations = organizations;
    },


};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};